export default __webpack_public_path__ + "static/media/small.3f18937c.jpg";